import { validationMixin } from 'vuelidate'
import { validationMessage } from 'vuelidate-messages'
import MESSAGES from '@/utilities/validation-messages'
import MaskMixin from '@/mixins/mask-mixin';

export default {
  mixins: [validationMixin, MaskMixin],

  methods: {
    validationMessage: validationMessage(MESSAGES),

    isValid (field) {
      const { $dirty, $error } = field
      return $dirty ? !$error : null
    }
  }
}
